module.exports = __webpack_public_path__ + "img/carroceria.48fd1155.png";